import { InputElementContainerSideBySidePositioning, InputElementMultilineTextArea } from "../../../text_inputs/main_content_inputs";

export function FormElementMissingData({ changeFunction }) {
  return (
    <InputElementContainerSideBySidePositioning
      label={"Handling Of Missing Data"}
    >
      <InputElementMultilineTextArea
        onChange={
          (event) => {
            changeFunction(event, "analysis_missing_variables");
          }
        }
      />
    </InputElementContainerSideBySidePositioning>
  )
}
